import React, { useEffect, useRef, useState } from 'react';
import styles from './addPost.module.css'
import {RiAddCircleFill,RiDeleteBin2Line} from 'react-icons/ri'
import {MdCancel} from 'react-icons/md'
import {useHistory} from 'react-router-dom'
import {BsPencil} from 'react-icons/bs'
import {GoMention,GoLocation} from 'react-icons/go'
import {GiCancel} from 'react-icons/gi'
import axios from 'axios';
import { toast } from 'react-toastify';
import { HighlightWithinTextarea } from 'react-highlight-within-textarea'


const EditableDiv =(props)=>{
    return(
        <div suppressContentEditableWarning={true} contentEditable>
            {props.children}
        </div>
    )
}




const Addimages=()=>{

    const addIconRef=React.useRef();
    const mentiondialog=React.useRef();
    const history =useHistory();
    const cap =useRef();

const [file,setFile]=useState(null);
const [previmages,setPrevimages]=useState([]);
const [value, setValue] = useState("X Y Z and then XYZ");
const [images,setImages]=useState([]);
const [location,setLocation]=useState();
const [mention, setMention]=useState("hkk");
const [mentionUsers,setMentionUsers]=useState([]);
const [showpdelet,setShowpdelet]=useState(false);
const [caption,setCaption]=useState("hello <mark>hasg</mark> hsh #tag hshs")
const [sample,setSample]=useState("");


const[usernames,setUsernames]=useState([
    "arhamchoudhary",
    "amir_ali",
    "tahir_parvez",
    "shaun_jp",
    "max_998",
    "blah",
    "text",
    "anothertest",
    "last_one"
])
const[mainpImage,setMainpImage]=useState("");
const [onmention,setOnmention]=useState(false);


const handleImageChnage=e=>{
   
if(images.length<=9&&e.target.files.length<=9){
    setImages((images)=>images.concat(Array.from(e.target.files))) 
    setMainpImage(URL.createObjectURL(e.target.files[0]))
    
    const  imgs= Array.from(e.target.files).map(i=>{
      return  {url:URL.createObjectURL(i)
                ,name:i.name}
    })

    setPrevimages((previmages)=>previmages.concat(imgs))      
}else{
    toast.error("You can not use more than 9 images in single post")
}
   

}

///"/#+([a-zA-Z0-9_]+)/"
    const heigligthash =
        {
            highlight:/#+([a-zA-Z0-9_]+)/,
            className: 'hashtag'
        }
    
const handlePostSubmit=()=>{

 
var formdata =new FormData();




// images.map(f=>{
//     formdata.append("file[]",f)
// })
mentionUsers.map(k=>{
    formdata.append("mention[]",k)
})

formdata.append("caption","caption")

    
  axios.post("https://vsam.me/api/api.php?request=createPost",formdata).then(res=>{
     console.log(res)
 }).catch(err=>{
     console.log(err)
 })




}

const regx= ()=>{
    const value = "arha #hsh"
    const arrvalue  =value.split(" ");
    
    var hash =  new RegExp('#+([a-zA-Z0-9_]+)')

    // arrvalue.map(i=>{
    //     if(hash.test(i)){
    //        setCapstion(<div style={{color:"red"}}>{i}</div>)
    //     }
    // })


   
    

}

function handlecaptionhanglechange(e){

    var hash =  new RegExp('#+([a-zA-Z0-9_]+)')
    console.log(cap.current.value)

   // setCaption(e)
}
   


useEffect(()=>{
    
    regx();
    // document.getElementById("addicon").click();
    addIconRef.current.click();
},[])


    return(
        <div className={styles.addImgCon}>
            
            
                {previmages.length!==0?
                <>
                {mainpImage?
                <div className={styles.mainpImage}>
                    <img src={mainpImage}/>
                    
                </div>:""}
                <div className={styles.prevSec}>
                <div className={styles.previmgs}>
                {previmages.map(e=>
                <div 
                className={styles.pimagecon} key={e.url}>
                <img 
                 onClick={()=>setMainpImage(e.url)}
                  src={e.url}/> 
                  {showpdelet?
                  <div className={styles.pdelet}><GiCancel
                  onClick={()=>{setImages(images.filter(i=>i.name!==e.name));
                           setPrevimages(previmages.filter(j=>j.name!==e.name))}}
                  /></div>:""}
                  </div>)}
                
                </div>
                <div className={styles.addImgicon}>
                <label htmlFor="fileimg">
                <RiAddCircleFill  id="addicon" />
                </label>
                <input id="fileimg" multiple ref={addIconRef} accept="image/*" onChange={handleImageChnage} type="file"/>
                <div style={{marginLeft:"4px"}}>
                <RiDeleteBin2Line onClick={()=>setShowpdelet(!showpdelet)} color={showpdelet?"#A40000":""} />
                    </div>
            </div>
                </div>
               </>:
               <div className={styles.onlyadd}>
                 <label htmlFor="fileimg">
                <RiAddCircleFill  id="addicon" />
                </label>
                <input id="fileimg"  multiple ref={addIconRef} accept="image/*" onChange={handleImageChnage} type="file"/>
            

               </div>
               
               }
          
          
         {onmention?
        <dialog className={styles.mentionDialog}>
            
            <div className={styles.closeicon}>
                <GiCancel onClick={()=>setOnmention(false)} />
            </div>
       
            <input type="text"  value={mention} onChange={(e)=>setMention(e.target.value)} placeholder="Search user"/>
            <div className={styles.insidedialog}>
            {mentionUsers?
            <div className={styles.mentionsec}>
            {mentionUsers.map(e=> 
             <div>
                {e}
               <MdCancel onClick={()=>setMentionUsers(mentionUsers.filter(i=>i!==e))} />
             </div>)}
             </div>:""}   
            
            
            {mention.length>3?
            <div className={styles.userList}>
                {usernames.map(e=>
                <div onClick={()=>{
                    setMentionUsers([...mentionUsers,e])
                    setMention("")
                    }} key={e}>{e}</div>)}
            </div>:""}
            </div>
        </dialog>:""} 
           
         
            <div className={styles.addImageInputs}>
            
                    
           

            
           
            <br/>
            {mentionUsers?
            <div className={styles.mentionsec}>
            {mentionUsers.map(e=> 
             <div>
                {e}
               <MdCancel onClick={()=>setMentionUsers(mentionUsers.filter(i=>i!==e))} />
             </div>)}
             </div>:""}   
            
             <HighlightWithinTextarea
            className={styles.textareasty}
           value={value}
              highlight={heigligthash}
             onChange= {event => setValue(event.target.value)}
    />

            <br/>
            <div className={styles.tagloc}>
            <div className={styles.locationinput}>
            <label><GoLocation/></label>
             <input value={location} onChange={(e)=>setLocation(e.target.value)} />
            </div>
            <div className={styles.tagbtn} onClick={()=>setOnmention(true)}><GoMention/> </div>
            </div>
            <br/>
            <button style={{width:"30%"}} onClick={handlePostSubmit} className="btn" >Post</button>
            </div>
            

            <br/>
            <br/>
            {sample?<span style={{color:"red"}}>{sample}</span>:""}
        </div>
    )
}

export default Addimages